/**
 * @generated SignedSource<<db6f9e6983efbfc8b7d84b3ca81d160e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DiscountDuration = "FIRST_ONLY" | "N_MONTHS" | "RECURRING" | "%future added value";
export type DiscountType = "FIXED" | "PERCENTAGE" | "%future added value";
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type CreatePromotionalCodeInput = {
  appliesTo?: ReadonlyArray<PlanSlug> | null;
  code: string;
  discountDuration?: DiscountDuration | null;
  discountType?: DiscountType | null;
  discountValue?: number | null;
  durationMonths?: number | null;
  expiresAt?: any | null;
  maxUses?: number | null;
  plan?: PlanSlug | null;
};
export type CreatePromotionalCodeMutation$variables = {
  input: CreatePromotionalCodeInput;
};
export type CreatePromotionalCodeMutation$data = {
  readonly CreatePromotionalCode: {
    readonly appliesTo: ReadonlyArray<PlanSlug>;
    readonly code: string;
    readonly createdAt: any;
    readonly currentUses: number;
    readonly discountDuration: DiscountDuration;
    readonly discountType: DiscountType | null;
    readonly discountValue: number | null;
    readonly durationMonths: number;
    readonly expiresAt: any | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly maxUses: number;
    readonly plan: PlanSlug | null;
    readonly planName: string | null;
    readonly planValueCents: number | null;
  };
};
export type CreatePromotionalCodeMutation = {
  response: CreatePromotionalCodeMutation$data;
  variables: CreatePromotionalCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionalCode",
    "kind": "LinkedField",
    "name": "CreatePromotionalCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planValueCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountDuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMonths",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliesTo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePromotionalCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePromotionalCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26c60a981f4e1527406c490c6c37e090",
    "id": null,
    "metadata": {},
    "name": "CreatePromotionalCodeMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePromotionalCodeMutation(\n  $input: CreatePromotionalCodeInput!\n) {\n  CreatePromotionalCode(input: $input) {\n    id\n    code\n    plan\n    planName\n    planValueCents\n    discountType\n    discountValue\n    discountDuration\n    durationMonths\n    appliesTo\n    isActive\n    maxUses\n    currentUses\n    expiresAt\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fabc2f50bef54d55c2a1acbaae8bf5f";

export default node;
